module.exports = __webpack_public_path__ + "static/media/DaciaSpirit-BlackV1500Latin-Cyrillic.dbbb485e.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/spirit/DaciaSpirit-BlackV1500Latin-Cyrillic.eot
// module id = 659
// module chunks = 0